import { React, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS file
import HomePage from './pages/HomePage';
function App() {

  useEffect(() => {
    AOS.init({
      // Global settings:
      duration: 400, // Reduced from 800ms to 400ms for faster animations
      once: true, // whether animation should happen only once - while scrolling down
      throttleDelay: 99, // Add throttle delay to improve performance
      disable: function() {
        // Disable on mobile devices to improve performance
        var maxWidth = 768;
        return window.innerWidth < maxWidth;
      },
      mirror: false, // Don't animate elements while scrolling past them
      anchorPlacement: 'top-bottom', // More predictable trigger point
      offset: 50, // Reduce offset for earlier triggering
      // other options can be found in AOS documentation
    });
    
    // Refresh AOS on window resize (throttled)
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        AOS.refresh();
      }, 250);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
